var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.24 14.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1b2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.24,4.44A4.44,4.44,0,0,0,15.8,0H4.44A4.44,4.44,0,0,0,0,4.44V9.73a4.44,4.44,0,0,0,4.44,4.44H15.8a4.44,4.44,0,0,0,4.44-4.44Zm-6.68,3L8.47,10c-.2.11-.88,0-.88-.27V4.56c0-.23.68-.37.88-.26L13.35,7C13.55,7.07,13.77,7.37,13.56,7.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.76c49731d2b7b6513eb013bba6198b0e.svg";
export { ForwardRef as ReactComponent };